import React from 'react'

const GameCard = () => {
  return (
    <div>
      <div className="img-box relative h-[110px] rounded-lg overflow-hidden shadow-md">
        <img
          src="/images/teenjoker.jpg"
          alt="teenjoker"
          className="w-full h-full object-cover"
        />
        <div className="absolute bottom-0 w-full text-center px-1 py-1 bg-gradient-to-b from-[#0088CC] to-[#2C3E50]">
          <a
            href="/"
            className="font-semibold text-white uppercase text-[10px] sm:text-[11px] md:text-[12px] tracking-wide block truncate"
          >
            Teenpatti Joker
          </a>
        </div>
      </div>
    </div>
  )
}

export default GameCard
